module.exports = __webpack_public_path__ + "img/title.316b037c.png";